import React, { useState, useRef, useContext, useEffect } from 'react';
import FilesContext from '../../context/FilesProvider';
import AuthContext from '../../context/AuthProvider';
// assets
import Back from '../../assets/back.svg';
import Upload from '../../assets/upload.svg';
import Loader from '../../helpers/Loader';
// api

const UploadCsv = ({ setShow }) => {
  // context
  const { loading, requestFileUpload } = useContext(FilesContext);
  const { datalogin } = useContext(AuthContext);
  // ref para el input
  const inputFile = useRef(null);

  const [types, setTypes] = useState([
    { title: 'Ajustes y extras', value: 'config' },
  ]);

  useEffect(() => {
    if (datalogin) {
      datalogin.service === 'YUMMER'
        ? setTypes([
            { title: 'Reportes - yummers', value: 'yummers' },
            ...types,
          ])
        : setTypes([
            { title: 'Reportes - comercios', value: 'commerces' },
            ...types,
          ]);
    }
  }, [datalogin]);

  // const types = [
  //   { title: 'Reportes - yummers', value: 'yummers' },
  //   { title: 'Reportes - comercios', value: 'commerces' },
  //   // { title: 'Reporte de Dispersion', value: 'dispertion' },
  //   { title: 'Ajustes y extras', value: 'config' },
  // ];

  // states
  // tipo de archivo
  const [fileType, setFileType] = useState(null); // 1 para dispersion, 2 para xlsx
  // string para definir hacia donde ira
  const [type, setType] = useState('');
  // archivo a subir
  const [file, setFile] = useState(undefined);
  const [fileName, setFileName] = useState(undefined);

  /**
   *
   * @param {json} data
   * funcion para setear la data del archivo seleccionado
   */
  const setFileData = (data) => {
    setFileName(data.files[0].name);
    setFile(data.files[0]);
  };

  /**
   *
   * @param {event} e
   * funcion para cambiar el tipo de servicio
   * entre yummers o comercios
   */
  const handleChangeType = (e) => {
    const value = e.target.value;
    setType(value);
    const data = types.find((el) => el.value === value);
    setFileType(data);
    clearData();
  };

  /**
   *
   * @param {number} type
   * funcion para setear estados cuando el selector esta abierto
   */
  const onOpenFileSelector = (type) => {
    inputFile.current.click();
  };

  /**
   * efecto para mostrar el selcet de acciones
   */
  useEffect(() => {
    if (file) {
      setShow(false);
      return;
    }
    setShow(true);
  }, [file, setShow]);

  /**
   * funcion para subir arcihvo
   */
  const uploadCsv = async () => {
    const res = await requestFileUpload(file, type, fileType);
    if (res) {
      clearData();
    }
  };

  const setFileExt = (type) => {
    switch (type) {
      case 'yummers':
        return '.xlsx';
      case 'commerces':
        return '.xlsx';
      case 'dispertion':
        return '.lis';
      case 'config':
        return '.xlsx';
      default:
        return '';
    }
  };

  /**
   * funcion para limpiar todos los estados
   */
  const clearData = () => {
    document.getElementById('file').value = '';
    setFile(undefined);
    setFileName(undefined);
  };

  /**
   * funcion para limpiar el tipo de servicio
   */
  const clearType = () => {
    setType('');
    setFileType(null);
  };

  return (
    <>
      {file && type && (
        <>
          <p className="title">Servicio</p>
          <p className="selected-service">{fileType.title}</p>
        </>
      )}
      {file && (
        <div>
          {(type === 'yummers' || type === 'commerces') && (
            <p className="title">Este es el archivo que deseas cargar?</p>
          )}
          {type === 'dispertion' && (
            <p className="title">
              Este es el archivo de dispersión que deseas cargar?
            </p>
          )}
          {type === 'config' && (
            <p className="title">
              Este es el archivo de ajuste que deseas cargar?
            </p>
          )}
          <p className="text-title">Archivo: {fileName}</p>
        </div>
      )}

      <input
        type="file"
        id="file"
        ref={inputFile}
        accept={setFileExt(type)}
        onChange={(e) => setFileData(e.target)}
        style={{ display: 'none' }}
      />
      {loading ? (
        <div className="actions">
          <Loader />
        </div>
      ) : (
        <>
          {file ? (
            <>
              <button onClick={uploadCsv} className="btn-yummy btn-bg">
                <img src={Upload} className="btn-image" alt="" srcset="" />
                Si, Cargar.
              </button>
              <button
                onClick={() => onOpenFileSelector(fileType)}
                className="btn-yummy btn-bg-disabled">
                No, elegir otro.
              </button>
            </>
          ) : (
            <>
              <div className="radios-container">
                {types.map((type) => {
                  return (
                    <label class="container-radio">
                      {type.title}
                      <input
                        type="radio"
                        name="radio"
                        value={type.value}
                        onChange={(e) => handleChangeType(e)}
                      />
                      <span class="checkmark-radio"></span>
                    </label>
                  );
                })}
              </div>
              <button
                onClick={() => onOpenFileSelector(type)}
                className={
                  type ? 'btn-yummy btn-bg' : ' btn-yummy btn-bg-disabled'
                }
                disabled={!type}>
                <img src={Upload} className="btn-image" alt="" srcset="" />
                Cargar archivo
              </button>
            </>
          )}

          {file && (
            <div
              className="back-button"
              onClick={() => {
                clearData();
                clearType();
              }}>
              <img src={Back} alt="" />
              <p>Atras</p>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default UploadCsv;
